<input
	class="radioItem"
	type="radio"
	[checked]="isSelected"
	[attr.aria-label]="params?.data?.file_name || 'Select row'"
	(click)="onClick()"
	(keydown.enter)="onKeydown($event)"
	(keydown.space)="onKeydown($event)" />
